import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import "component/modal/Reject/styles.scss";

class RejectModal extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { onClose } = this.props;
    if (this.modalRef && !this.modalRef.contains(event.target)) {
      onClose();
    }
  }

  render() {
    const { isOpen, onReject, onClose, t } = this.props;

    if (!isOpen) return null;

    return (
      <div className="reject-container modal" role="dialog">
        <div 
          className="modal-dialog modal-dialog-centered" 
          role="document"
          ref={(ref) => this.modalRef = ref}
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className="question">
                {t('rejectFreeSpins')}
              </div>
              <div className="button-group">
                <button className="btn text-nowrap w-100 reject-button" onClick={onReject}>
                  {t('reject')}
                </button>
                <button className="btn text-nowrap w-100 no-button" onClick={onClose}>
                  {t('no')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("translation")(RejectModal);
